module.exports = __webpack_public_path__ + "img/calendar-1.f182a78f.svg";